import { render, staticRenderFns } from "./ModalModality.vue?vue&type=template&id=9d06fc76"
import script from "./ModalModality.vue?vue&type=script&lang=js"
export * from "./ModalModality.vue?vue&type=script&lang=js"
import style0 from "./ModalModality.vue?vue&type=style&index=0&id=9d06fc76&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports